module.exports = __webpack_public_path__ + "img/advantages-bg--991.6bc7ea5.webp";